import React from 'react';

import Icon from 'shared/Icon';
import { useT } from 'client/i18n/hooks/useT';
import { StyledPauseButton, StyledPlayButton, VisuallyHidden } from './styles';

type Props = {
  onClick: () => void;
  isDisabled?: boolean;
};

export function PlayButton({ onClick, isDisabled = false }: Props) {
  const t = useT();
  return (
    <StyledPlayButton onClick={onClick} disabled={isDisabled}>
      <VisuallyHidden>
        {t(
          'SplitSegmentAudioModalScreen.PlaybackButtons.PlayButton',
          'play audio',
          'Play audio button text'
        )}
      </VisuallyHidden>
      <div>
        <Icon type="play" fillColor="white" />
      </div>
    </StyledPlayButton>
  );
}

export function PauseButton({ onClick, isDisabled = false }: Props) {
  const t = useT();
  return (
    <StyledPauseButton onClick={onClick} disabled={isDisabled}>
      <VisuallyHidden>
        {t(
          'SplitSegmentAudioModalScreen.PlaybackButtons.PauseButton',
          'pause audio',
          'Pause audio button text'
        )}
      </VisuallyHidden>
    </StyledPauseButton>
  );
}
